export default __webpack_public_path__ + "static/media/tamin-ejtemai.357fb231.png";